import axios from 'axios';
import {
  REPORT_CONFIG_GET_REQUEST,
  REPORT_CONFIG_GET_SUCCESS,
  REPORT_CONFIG_GET_FAIL,
  REPORT_CONFIG_UPDATE_REQUEST,
  REPORT_CONFIG_UPDATE_SUCCESS,
  REPORT_CONFIG_UPDATE_FAIL,
} from '../constants/reportConstants';

export const getReportConfig = () => async (dispatch, getState) => {
  try {
    dispatch({ type: REPORT_CONFIG_GET_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.accessToken}`,
      },
    };

    const { data } = await axios.get(process.env.REACT_APP_GOLANGAPI + '/api/users/report/config', config);

    dispatch({
      type: REPORT_CONFIG_GET_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: REPORT_CONFIG_GET_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateReportConfig = (reportConfig) => async (dispatch, getState) => {
  try {
    dispatch({ type: REPORT_CONFIG_UPDATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${userInfo.accessToken}`,
      },
    };

    const { data } = await axios.put(process.env.REACT_APP_GOLANGAPI + '/api/users/report/config', reportConfig, config);

    dispatch({
      type: REPORT_CONFIG_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: REPORT_CONFIG_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
}; 